import { BlurInH2 } from '@/components/eldora-ui/blur-in-h2';
import TitleBox from './TitleBox';
import { BlurInH3 } from '@/components/eldora-ui/blur-in-h3';
import { CircleArrowRight } from 'lucide-react';
import Link from 'next/link';

const LearnMore = () => {
  return (
    <section
      className="scroll-mt-[150px] bg-gray-50"
      id="technology-certifications"
    >
      <div className="col-span-1"></div>
      {/* Desktop View */}
      <div className="col-span-4 hidden md:grid grid-cols-8 gap-0 h-[700px] ml-12">
        {/* First Half - 3 Columns */}
        <div className="col-span-4 grid grid-cols-4 grid-rows-3">
          {/* Top Section */}
          <div className="col-span-3 row-span-1">
            <div className="row-span-1 flex flex-col">
              <BlurInH3 className="mt-2 whitespace-pre-line tracking-widest">
                {'Learn more about\n our Simplicity'}
                <sup className="text-xl">®</sup>
                <span className="font-light text-[#BF984D] whitespace-pre-line">
                  {'\nPartner Network'}
                </span>
              </BlurInH3>
            </div>
          </div>

          {/* Bottom Section */}
          <div className="col-span-4 row-span-2 grid grid-cols-4 grid-rows-2 border border-r-0 border-[#BF984D]">
            <div
              className="col-span-2 row-span-2 bg-image grid grid-rows-2"
              style={{
                backgroundImage: `url('/TechnologyCertifications/tc1.svg')`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
              }}
            >
              <div className="col-span-1 row-span-1 row-start-1 bg-[rgba(211,211,211,0.5)]" />
              <div className="col-span-2 row-span-1 row-start-2 bg-[rgba(211,211,211,0.5)]" />
            </div>
            {/* First card */}
            <Link
              href={'/partners/professional-services-providers'}
              aria-label={`Read more about Simplicity® Certification Program Benefits.`}
              className={`col-span-2 row-span-1 p-4 bg-[#f8f8f8] transition-colors transition-background duration-500 group hover:text-[#BF984D] hover:bg-[#E0E0E0] border border-r-0 border-[#BF984D]`}
            >
              <div className="flex flex-col justify-end items-start h-full mt-2">
                <div className="flex flex-col justify-between items-start h-full">
                  <div className="flex flex-col justify-start">
                    <span className="text-[1.05rem] text-[#BF984D] whitespace-pre-line">
                      Simplicity® Certification{' '}
                    </span>
                    <span className="text-[1.05rem] whitespace-pre-line">
                      Program Benefits.{' '}
                    </span>
                  </div>
                  <span className="text-[1.05rem] pb-4 whitespace-pre-line">
                    {
                      'Learn more about the \nbenefits from our certification\n programs.'
                    }
                  </span>
                </div>
                <CircleArrowRight
                  className="text-lg text-[#BF984D] transition-transform group-hover:translate-x-1 duration-500 mb-2"
                  aria-hidden="true"
                  size="32"
                />
              </div>
            </Link>
            <div
              className="col-span-2 row-span-1 bg-image grid grid-rows-2"
              style={{
                backgroundImage: `url('/TechnologyCertifications/tc4.svg')`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
              }}
            ></div>
          </div>
        </div>

        {/* Second Half - 4 Columns */}
        <div className="col-span-4 grid grid-cols-4 grid-rows-3 border border-[#BF984D]">
          {/* Top Section */}
          <div
            className="col-span-4 row-span-2 bg-image grid grid-rows-2 grid-cols-4"
            style={{
              backgroundImage: `url('/TechnologyCertifications/tc2.svg')`,
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
            }}
          >
            <TitleBox
              title={'Simplicity®\n Certified'}
              subtitle={'Low Code Development Platform (LCDP) Developer'}
              link={'/partners/professional-services-providers'}
              isExternal={false}
              colSpan={1}
              rowSpan={1}
            />
            <div className="col-span-1 row-span-1 col-start-2 bg-[rgba(211,211,211,0.5)] border border-[#BF984D]" />
            <div className="col-span-1 row-span-1 col-start-3 border border-[#BF984D]" />
            <div className="col-span-1 row-span-1 col-start-4 border border-[#BF984D]" />
            <div className="col-span-1 row-span-1 row-start-2 bg-[rgba(211,211,211,0.5)] border border-[#BF984D]" />
            {/* First card */}
            <Link
              href={'/partners/professional-services-providers'}
              aria-label={`Read more about Simplicity® Certification Program Benefits.`}
              className={`col-span-1 row-span-1 p-4 bg-[#f8f8f8] transition-colors transition-background duration-500 group hover:text-[#BF984D] hover:bg-[#E0E0E0] border border-r-0 border-[#BF984D]`}
            >
              <div className="flex flex-col justify-end items-start h-full mt-2">
                <div className="flex flex-col justify-between items-start h-full">
                  <span className="text-[1.05rem] pb-4 whitespace-pre-line">
                    {'Simplicity®\n Certified\n LCDP Architect'}
                  </span>
                </div>
                <CircleArrowRight
                  className="text-lg text-[#BF984D] transition-transform group-hover:translate-x-1 duration-500 mb-2"
                  aria-hidden="true"
                  size="32"
                />
              </div>
            </Link>
            <div className="col-span-1 row-span-1 row-start-2 border border-[#BF984D]" />
            <div className="col-span-1 row-span-1 col-start-4 bg-[rgba(211,211,211,0.5)] border border-[#BF984D]" />
          </div>

          {/* Bottom Section */}
          <div
            className="col-span-4 row-span-2 grid grid-rows-1 grid-cols-2 border border-[#BF984D]"
            style={{
              backgroundImage: `url('/TechnologyCertifications/tc3.svg')`,
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat',
            }}
          >
            <div className="col-span-1 row-span-1 col-start-2 bg-[rgba(211,211,211,0.5)] border-l-2 border-[#BF984D]" />
          </div>
        </div>
      </div>
      {/* Mobile View */}
      <div className="block md:hidden">
        <div className="text-start text-3xl mb-6">
          <BlurInH2 className="">
            Technology{' '}
            <span className="font-light text-[#BF984D]">Certifications</span>
          </BlurInH2>
        </div>
        <div className="flex flex-col space-y-6">
          <TitleBox
            key={0}
            title={'Simplicity® Certification Program Benefits.'}
            subtitle="Learn more about the  benefits from our certification programs."
            link={'/partners/professional-services-providers'}
            isExternal={false}
          />
          <TitleBox
            key={1}
            title={'Simplicity® Certified'}
            subtitle="Low Code Development Platform (LCDP) Developer"
            link={'/partners/professional-services-providers'}
            isExternal={false}
          />
          <TitleBox
            key={2}
            title={''}
            subtitle="Simplicity® Certified LCDP Architect"
            link={'/partners/professional-services-providers'}
            isExternal={false}
          />
        </div>
      </div>
    </section>
  );
};

export default LearnMore;
